import React from 'react';
import OnOffField from '../OnOffField';
import SelectWithFilter from './SelectWithFilter';

export default class SelectFieldCheckbox extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    showSelectFilterAt: 10,
    filterCleared: false,
    selectValues: [],
    IsCheckBoxEnabled: false,
    onOffValue: false,
    editedItem: {},
    changeOfEditedMultipItem: () => {},
    fieldName: 'defaultFieldname',
    onChange: () => {},
    onFilterChange: null,
    filterPlaceholder: 'Type to search...',
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  renderSelectField() {
    return (
      <SelectWithFilter
        value={this.props.value}
        onChange={(e) => {
          this.props.onChange(this.props.fieldName, e.value);
        }}
        className={this.props.className}
        showSelectFilterAt={this.props.showSelectFilterAt}
        selectValues={this.props.selectValues}
        filterCleared={this.props.filterCleared}
        onFilterChange={this.props.onFilterChange}
        filterPlaceholder={this.props.filterPlaceholder}
      />
    );
  }

  render() {
    if (this.props.IsCheckBoxEnabled === false) return this.renderSelectField();

    if (this.props.editedItem[`${this.props.fieldName}Orgin`] === undefined) {
      this.props.editedItem[`${this.props.fieldName}Orgin`] = this.props.value;
      this.props.editedItem[`${this.props.fieldName}Status`] =
        this.props.onOffValue === '' ? false : this.props.onOffValue;
    }
    const onOffValue = this.props.editedItem[`${this.props.fieldName}Status`];
    return (
      <div className='inputCheckBoxCombo'>
        <div className='figmaOnOffButtonBox'>
          <OnOffField
            value={onOffValue}
            onChange={(newValue) => {
              if (newValue === false) {
                this.props.changeOfEditedMultipItem([
                  { fieldName: `${this.props.fieldName}Status`, newValue },
                  { fieldName: this.props.fieldName, newValue: this.props.editedItem[`${this.props.fieldName}Orgin`] },
                ]);
              } else {
                this.props.onChange(`${this.props.fieldName}Status`, newValue);
              }
            }}
          />
        </div>
        {onOffValue ? this.renderSelectField() : <div className='inputFigma' />}
      </div>
    );
  }
}
